export default "__VITE_ASSET__706a7daa__"